import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../http";
import { useForBindingId } from "../../../forBinding";
import { getApiErrorMessage, toApiError } from "../utils";

export const useDeleteParcelling = () => {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();

	return useMutation({
		mutationFn: async (id: string) => {
			try {
				return (
					await api.delete(`/advices/parcelling/delete/${id}`, {
						params: { forBinding },
					})
				).data;
			} catch (error) {
				throw toApiError(error, "Erro ao deletar parcelamento");
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["parcelling"] });
		},
		onError: (error) => {
			console.error("Erro ao deletar parcelamento:", getApiErrorMessage(error, "Erro ao deletar parcelamento"));
		},
	});
};
